// Module
var code = "<span class=\"label-toggler ellipsis\" ng-class=\"{'is-shrink': $ctrl.isShrink}\" ng-attr-style=\"background: {{$ctrl.labelColor}}\" ng-click=\"$ctrl.onToggle()\"> <i class=\"ti-folder\" ng-if=\"$ctrl.isFolderIcon && !$ctrl.isShrink\"></i> {{!$ctrl.isShrink ? $ctrl.labelName : ''}} </span> ";
// Exports
module.exports = code;